import {
  APP_CATEGORY_CHART_FETCH_REQUEST,
  APP_CATEGORY_CHART_FETCH_REQUEST_SUCCESS,
  APP_CATEGORY_CHART_FETCH_REQUEST_FAILURE,
  APP_CATEGORY_CHART_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const appCategoryChartsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case APP_CATEGORY_CHART_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case APP_CATEGORY_CHART_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case APP_CATEGORY_CHART_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case APP_CATEGORY_CHART_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        errors: {},
        loading: false,
      });

    default:
      return state;
  }
};

export default appCategoryChartsReducer;
